export default {
    delete: 'ลบข้อมูล',
    cancel: 'ยกเลิก'
}
